import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {LikeCommentInput} from '../../graphql/generated/types';

/**
 * 댓글 좋아요/좋아요 취소
 *
 * Origin: pageNicolasApi.likeComment
 * API: POST /api/v5/store/community/like
 */
export async function postStoreCommunityLike(
  likeCommentInput: LikeCommentInput,
  options?: FetcherOptions
): Promise<ApiResultVo & {like_count: number}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v5/store/community/like',
    {
      method: 'POST',
      data: {
        commentuid: likeCommentInput.commentUid,
        like: likeCommentInput.like,
      },
    },
    options
  );
  return response.data;
}
